/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import type { OperationType } from 'relay-runtime';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

type JourneysHorizontalNavEntryPointComponent = EntryPointComponent<
	Record<string, OperationType>,
	// oxlint-disable-next-line @typescript-eslint/no-explicit-any
	Record<string, EntryPoint<any, any> | undefined>,
	{},
	{} | null
>;

export const journeysHorizontalNavEntryPoint: EntryPoint<
	JourneysHorizontalNavEntryPointComponent,
	{}
> = createEntryPoint({
	root: JSResourceForUserVisible<JourneysHorizontalNavEntryPointComponent>(
		/* webpackChunkName: "async-journeys-horizontal-nav", jiraSpaEntry: "async-journeys-horizontal-nav" */ './src/JourneysHorizontalNav.tsx',
		{
			includeInShellOnlySsrBundle: true,
			entryFsSsrLiftImportToModule: true,
		},
	),
	getPreloadProps: () => ({
		queries: {},
		entryPoints: {},
		extraProps: {},
	}),
});
